import type { ComponentProps, FC } from "react";

import type { DirectionalIconComponent } from "@jti/brand-icons";
import { DeviceVideoIcon } from "@jti/brand-icons/device-video";
import { UiArticleIcon } from "@jti/brand-icons/ui-article";
import { UiQuizIcon } from "@jti/brand-icons/ui-quiz";
import type { LoyaltyEarningType } from "@jti/rest-api-types";

export type UseBlogArticleTypeIconParams = {
  articleType: LoyaltyEarningType;
};

const iconMap: Partial<Record<UseBlogArticleTypeIconParams["articleType"], FC>> = {
  article: UiArticleIcon,
  video: DeviceVideoIcon,
  quiz: UiQuizIcon,
};

export const getBlogArticleTypeIcon = ({ articleType }: UseBlogArticleTypeIconParams): DirectionalIconComponent => {
  return (props: ComponentProps<DirectionalIconComponent>) => {
    const Element = iconMap[articleType];

    if (!Element) {
      return null;
    }

    return <Element {...props} />;
  };
};
